import React from "react";

export default function AboutProjectUk() {
  return (
    <div style={{ maxWidth: 880, marginTop: 40, marginBottom: 40, padding: 24 }}>

      <h1 style={{ fontWeight: 900, fontSize: 36, marginBottom: 28 }}>
        Про Radiomonitor.net
      </h1>
      <p style={{ fontSize: 18, marginBottom: 34 }}>
        <b>Radiomonitor.net</b> — це сучасна аналітична платформа для онлайн-радіо, яка забезпечує повний контроль, моніторинг та глибокий аналіз вашої аудиторії в реальному часі. Сервіс спеціально розроблений для потреб радіостанцій, які прагнуть розуміти свою аудиторію, підвищувати лояльність слухачів і точно вимірювати ефективність ефіру та рекламних кампаній.
      </p>

      <hr style={{ margin: "36px 0" }} />

      <h2 style={{ fontWeight: 800, fontSize: 26, marginBottom: 16 }}>
        🛠️ Готові модулі системи
      </h2>
      <p style={{ marginBottom: 12 }}>
        Наша система має низку потужних вбудованих модулів:
      </p>
      <ul style={{ fontSize: 18, marginBottom: 36 }}>
        <li>🧑‍💻 <b>Generic Listeners</b> — відображення активних слухачів з фільтрами, сортуванням та автооновленням;</li>
        <li>📍 <b>Geo-аналітика</b> — карти та таблиці з розподілом слухачів за країнами та містами;</li>
        <li>📊 <b>Generic Live & Count</b> — онлайн-таблиця з живими даними та окремим лічильником;</li>
        <li>📈 <b>Reklama Stats</b> — детальна статистика прослуховування рекламних блоків;</li>
        <li>📉 <b>TSL-аналітика</b> — модуль тривалості прослуховування;</li>
        <li>🆕 <b>Нові випадки</b> — виявлення нових IP/UA та розділення реальних і технічних підключень;</li>
        <li>🗃️ <b>Aggregator</b> — централізована агрегація даних із кількох джерел;</li>
      </ul>

      <hr style={{ margin: "36px 0" }} />

      <h2 style={{ fontWeight: 800, fontSize: 26, marginBottom: 16 }}>
        📌 Чому обирають нас
      </h2>
      <ul style={{ fontSize: 18, marginBottom: 36 }}>
        <li><b>Гнучкість:</b> система працює з Icecast, Shoutcast, HLS, Wowza та іншими серверами;</li>
        <li><b>Точність:</b> використовуємо промислові метрики — AQH, TSL, Cume, AAS, TLH, GRP тощо;</li>
        <li><b>Реальний час:</b> відображення онлайн-статистики без затримок;</li>
        <li><b>Безпека:</b> система повністю самостійна, не вимагає сторонніх SaaS або API;</li>
      </ul>

      <hr style={{ margin: "36px 0" }} />

      <h2 style={{ fontWeight: 800, fontSize: 26, marginBottom: 16 }}>
        🚀 Постійний розвиток
      </h2>
      <p style={{ fontSize: 18, marginBottom: 12 }}>
        Ми <b>постійно вдосконалюємо</b> платформу, додаючи:
      </p>
      <ul style={{ fontSize: 18, marginBottom: 36 }}>
        <li>Нові метрики (включно зі стандартами IAB, Nielsen);</li>
        <li>Нові візуалізації;</li>
        <li>Підтримку інтеграції з BI-системами (Power BI, Data Studio, Grafana);</li>
      </ul>

      <hr style={{ margin: "36px 0" }} />

      <h2 style={{ fontWeight: 800, fontSize: 26, marginBottom: 16 }}>
        🖥️ Приєднуйтесь
      </h2>
      <p style={{ fontSize: 18, marginBottom: 14 }}>
        Radiomonitor.net — це не просто лічильник слухачів. Це <b>аналітичний мозок</b> вашої радіостанції.
      </p>
      <p style={{ fontSize: 18 }}>
        Підключайтеся вже сьогодні — і перетворіть свої дані на реальні рішення.
      </p>
    </div>
  );
}
